import { sendCloseAvailToChannel } from '../../utils/HelpersChannel'
import { firebaseDb } from '../../config/firebaseConfig'


async function createReservation(agencyId, experienceId, reservation) {
  const reservationID = await firebaseDb
    .collection(`agency/${agencyId}/experiences/${experienceId}/reservation`)
    .add(reservation)
    .then((docRef) => docRef.id)

  await firebaseDb
    .doc(
      `agency/${agencyId}/experiences/${experienceId}/reservation/${reservationID}`,
    )
    .update({ key: reservationID })

  return reservationID
}

const getAllReservationsForExperience = async (agencyId, experienceId) => {
  try {
    const reservations = []

    const reservationCollection = firebaseDb
      .collection('/agency')
      .doc(agencyId)
      .collection('/experiences')
      .doc(experienceId)
      .collection('reservation')

    const collection = await reservationCollection.get()

    collection.forEach((doc) => {
      reservations.push(doc.data())
    })

    return reservations
  } catch (error) {
    console.error('Error al obtener las reservaciones:', error)
    throw error
  }
}

function calculateRangeHour(checkinHour, checkoutHour) {
  const hour = parseInt(checkinHour.split(':')[0])
  const exitHour = parseInt(checkoutHour.split(':')[0])
  const hours = []

  let actualHour = hour
  while (true) {
    hours.push(actualHour.toString().padStart(2, '0') + ':00')
    if (actualHour === exitHour) break
    actualHour = (actualHour + 1) % 24
  }

  return hours
}

const formatDate = (date) => {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')

  return `${year}-${month}-${day}`
}

const getDateRangeMap = (startDate, endDate) => {
  // Convertir las fechas de texto a objetos Date
  const start = new Date(startDate)
  start.setDate(start.getDate() + 1) // Sumar un día a la fecha de inicio
  const end = new Date(endDate)
  end.setDate(end.getDate() + 1) // Sumar un día a la fecha de fin

  // Crear un objeto mapa para almacenar el rango de fechas
  const dateRangeMap = {}

  // Incrementar la fecha de inicio hasta un día antes de la fecha de salida
  const currentDate = new Date(start)
  while (currentDate < end) {
    const formattedDate = formatDate(currentDate)
    dateRangeMap[formattedDate] = true // Agregar la fecha al mapa con valor true
    currentDate.setDate(currentDate.getDate() + 1) // Incrementar la fecha en un día
  }
  // Retornar el mapa con el rango de fechas
  return dateRangeMap
}

async function assignResource(agencyId, experienceData, reservation, overBooking = false) {
  try {
    const refRes = await firebaseDb
      .collection(`agency/${agencyId}/resources`)
      .where(
        'idsExperiences',
        'array-contains',
        !!experienceData.key ? experienceData.key : experienceData,
      )
      .where('isActive', '==', true).get();

    const singleResources = [];
    const nonSingleResources = [];

    // Separate resources into single and non-single
    for (let r of refRes.docs) {
      const resourceData = r.data();
      if (!!resourceData?.isSingle) {
        singleResources.push({ ...resourceData, id: r.ref.path });
      } else {
        nonSingleResources.push({ ...resourceData, id: r.ref.path });
      }
    }

    const countOccurrencesInObjects = (date, objectsObject) => {
      let count = 0
      for (const key in objectsObject) {
        const obj = objectsObject[key]

        if (obj?.daysRange?.[date]) {
          count++
        }
      }
      return count
    }

    // Process a single resource if there are any
    if (singleResources.length > 0) {
      let aviableResources = []


      for (const resource of singleResources) {

        // Formateo fechas
        let startDate
        let endDate
        if (experienceData.category === 'HOTEL') {
          startDate = new Date(reservation.dayFrom);
          endDate = new Date(reservation.dayTo);
        } else if (experienceData.category === 'AGENCY') {
          startDate = new Date(reservation.day);
          endDate = new Date(reservation.day);
        } else if (experienceData.category === 'PROGRAM' || experienceData.category === 'TAILORMADE') {
          const duration = experienceData.activities.length ? experienceData.activities.length : experienceData.minimumDays
          startDate = new Date(reservation.day);
          endDate = new Date(startDate.getTime() + duration * 24 * 60 * 60 * 1000); // Adding days
        }

        // Get aviability usage from resource
        const lastAvailability = await checkAvailabilityUsage(agencyId, resource.id.split("/").pop());

        if (resource.isPrivate) {
          for (let currentDate = startDate; currentDate < endDate; currentDate.setDate(currentDate.getDate() + 1)) {

            let currentDateString = currentDate.toISOString().split('T')[0];
            let nextDate = new Date(currentDate);
            nextDate.setDate(nextDate.getDate() + 1);

            const occurrences = countOccurrencesInObjects(
              currentDateString,
              lastAvailability,
            );
            if (resource.quantity - occurrences - 1 >= 0) { // Cantidad de recurso por dia - cantidad de reservas hechas para ese dia - reserva acutal
              // si el recurso tiene disponibilidad
              aviableResources.push({ ...resource, availability: resource.quantity - occurrences - 1 })
            } else if (overBooking) {
              // si es un overbooking
              aviableResources.push({ ...resource, availability: resource.quantity - occurrences - 1 })
            }
          }
        } else if (!resource.isPrivate) {
          // Si el recurso es publico
          const countTotalUsedInObjects = (date, objectsObject) => {
            let count = 0
            for (const key in objectsObject) {
              const obj = objectsObject[key]

              if (obj.daysRange[date]) {
                count = count + obj.used
              }
            }
            return count
          }

          let totalPersons = reservation.childs + reservation.persons

          for (let currentDate = startDate; currentDate < endDate; currentDate.setDate(currentDate.getDate() + 1)) {

            let currentDateString = currentDate.toISOString().split('T')[0];
            let nextDate = new Date(currentDate);
            nextDate.setDate(nextDate.getDate() + 1);

            const occurrences = countTotalUsedInObjects(
              currentDateString,
              lastAvailability,
            )
            if (resource.quota - occurrences - totalPersons >= 0) { // Capacidad total de recurso por dia - cantidad de pasajeros para ese dia - cantidad de pasajeros acutal
              // si el recurso tiene disponibilidad
              aviableResources.push({ ...resource, availability: resource.quota - occurrences - totalPersons })
            } else if (overBooking) {
              // si es un overbooking
              aviableResources.push({ ...resource, availability: resource.quantity - occurrences - 1 })
            }
          }
        }
      }

      // CASOS DE USO DE RECURSOS SINGLE
      function selectResource(aviableResources) {
        // Separate public and private resources
        const publicResources = aviableResources.filter(resource => !resource.isPrivate);
        const privateResources = aviableResources.filter(resource => resource.isPrivate);

        // If there are public resources, sort them by availability and prioritize them
        if (publicResources.length > 0) {
          publicResources.sort((a, b) => b.availability - a.availability);
          // Return the public resource with the highest availability
          return publicResources[0];
        }

        let startDate = new Date(reservation.dayFrom);
        let endDate = new Date(reservation.dayTo);
        const differenceInMilliseconds = endDate.getTime() - startDate.getTime();
        const differenceInDays = Math.floor(differenceInMilliseconds / (1000
          * 60 * 60 * 24));

        console.log("Difference in days:", differenceInDays);

        const personasAgrupadas = privateResources.reduce((acc, resources) => {
          acc[resources.name] = (acc[resources.name] || 0) + 1;
          return acc;
        }, {});

        const resourceCandidate = Object.keys(personasAgrupadas).find(
          (nombre) => personasAgrupadas[nombre] === differenceInDays
        );

        const resource = privateResources.filter(item => item.name === resourceCandidate)[0];
        debugger

        // If all resources are private, return the first private resource
        return resource
      }

      const selectedResource = selectResource(aviableResources);

      // OVERBOOKINGS?
      if (!!selectedResource) {
        await processResource(selectedResource, experienceData, reservation);
      } else {
        console.log('no hay disponibilidad en los recursos para esta reserva')
      }
    }

    // Los que no son single se consumen todos
    for await (let r of nonSingleResources) {
      await processResource(r, experienceData, reservation);
    }
  } catch (error) {
    console.log(error)
  }
}

// Helper function to process each resource
async function processResource(resource, experienceData, reservation) {
  if (experienceData.type === 'PXH') {
    const data = {
      checkinDate: reservation.day,
      checkoutDate: reservation.exitDay,
      checkinHour: reservation.hour,
      checkoutHour: reservation.exitHour,
      hourRange: calculateRangeHour(reservation.hour, reservation.exitHour),
      experience: reservation.experience,
      reservationId: reservation.key,
      name: `${reservation.name} ${reservation.lastName}`,
      used: parseInt(reservation.persons + reservation.childs),
    };
    await firebaseDb.collection(`${resource.id}/availability`).add(data);
  } else if (experienceData.category === 'HOTEL') {
    let checkDay = reservation.day;
    let checkExitDay = reservation.dayTo;

    const data = {
      checkinDate: reservation.day,
      checkoutDate: reservation.dayTo,
      daysRange: getDateRangeMap(checkDay, checkExitDay),
      hour: reservation.hour,
      experience: reservation.experience,
      reservationId: reservation.key,
      name: `${reservation.name} ${reservation.lastName}`,
      used: parseInt(reservation.persons + reservation.childs),
    };
    await firebaseDb.collection(`${resource.id}/availability`).add(data);
  } else {
    const data = {
      day: reservation.day,
      hour: reservation.hour,
      experience: reservation.experience,
      reservationId: reservation.key,
      name: `${reservation.name} ${reservation.lastName}`,
      used: parseInt(reservation.persons + reservation.childs),
    };
    await firebaseDb.collection(`${resource.id}/availability`).add(data);
  }
}

function getReservationDetails(agencyId, experienceId, reservationId) {
  return firebaseDb
    .collection('/agency')
    .doc(agencyId)
    .collection('/experiences')
    .doc(experienceId)
    .collection('reservation')
    .doc(reservationId)
    .get()
    .then((doc) => {
      return doc.data()
    })
}

async function getServiceByDayAndHour(data) {
  return firebaseDb
    .collection(
      `agency/${data.agencyId}/experiences/${data.experienceId}/services`,
    )
    .where('day', '==', data.day)
    .where('hour', '==', data.hour)
    .get()
    .then((snapShotQuery) => {
      let data = {}
      snapShotQuery.forEach((doc) => {
        data = { ...doc.data(), key: doc.id }
      })
      return data
    })
}

async function checkAvailabilityHotels(agencyId, resourceId) {
  // const formattedDate = date.toISOString().split('T')[0]

  const query = firebaseDb.collection(
    `agency/${agencyId}/resources/${resourceId}/availability`,
  )

  const snapshot = await query.get()
  const resources = []
  snapshot.forEach((doc) => {
    resources.push({ ...doc.data(), resourceId: resourceId })
  })
  return resources
}

async function checkAvailabilityForResource(resourceId, date, data) {
  const formattedDate = date.toISOString().split('T')[0]
  const query = firebaseDb
    .collection(
      `/agency/d${data.agencyId}/resources/${resourceId}/availability`,
    )

    .where('checkinDate', '==', formattedDate)
  const snapshot = await query.get()

  const resources = []
  snapshot.forEach((doc) => {
    resources.push(doc.data())
  })

  return resources

  // console.log(formattedDate)
  //   const checkinQuery = firebaseDb
  //     .collection(`/agency/mYDrLDtCRCNhk59ymUEc/resources/${resourceId}/availability`)
  //     .where('checkinDate', '==', formattedDate)
  //     .get();
  // console.log(checkinQuery)
  //   const checkoutQuery = firebaseDb
  //     .collection(`resources/${resourceId}/availability`)
  //     .where('checkoutDate', '==', formattedDate)
  //     .get();
  //     console.log(checkoutQuery)

  //   const [checkinSnapshot, checkoutSnapshot] = await Promise.all([
  //     checkinQuery,
  //     checkoutQuery,
  //   ]);
  //   const availabilityDocs = [];
  //   console.log(availabilityDocs)
  //   checkinSnapshot.docs.forEach((doc) => {
  //     availabilityDocs.push(doc.data());
  //   });

  //   checkoutSnapshot.docs.forEach((doc) => {

  //     availabilityDocs.push(doc.data());
  //   });
  //
  //   return availabilityDocs;
}

async function getAllServices(data) {
  return firebaseDb
    .collection(
      `agency/${data.agencyId}/experiences/${data.experienceId}/services`,
    )
    .get()
    .then((snapShotQuery) => {
      let services = []
      snapShotQuery.forEach((doc) => {
        services.push({ ...doc.data(), key: doc.id })
      })
      return services
    })
}

async function getResourcesByDayAndHour(data) {
  const resources = []

  const refRes = await firebaseDb
    .collection(`agency/${data.agencyId}/resources`)
    .where('idsExperiences', 'array-contains', data.experienceId)
    .get()

  refRes.forEach(async (doc) => {
    const resourceData = doc.data()
    if (resourceData.isActive) {
      resources.push({
        id: doc.id,
        ...resourceData,
      })
    }
  })
  return resources
}

async function getResourcesHotelByDayAndHour(data) {
  const resources = []
  //Obtiene recursos asociados a una exp
  const refRes = await firebaseDb
    .collection(`agency/${data.agencyId}/resources`)
    .where('idsExperiences', 'array-contains', data.experienceId)
    .get()

  for (let r of refRes.docs) {
    //Consulta si existe disponibilidades en los recursos
    const refAva = await firebaseDb
      .collection(`${r.ref.path}/availability`)
      .where('day', '>=', data.start)
      .where('day', '<=', data.end)
      .where('experience', '==', data.experienceId)
      .get()
    // Si no existe la collecition availability significa que tiene disponibilidad
    if (!refAva.empty) {
      const availability = []
      for (let ra of refAva.docs) {
        const ind = availability.findIndex((a) => a.key === ra.id)
        if (ind === -1) {
          availability.push({
            key: ra.id,
            ...ra.data(),
            ref: ra.ref.path,
          })
        } else {
          return
        }
      }
      resources.push({
        data: r.data(),
        availability: availability,
      })
    } else {
      resources.push({ data: r.data(), availability: [] })
    }
  }
  return resources
}

function updateServiceReservations(data) {
  const { agencyId, experienceId, serviceId, reservations } = data

  return firebaseDb
    .collection(`agency/${agencyId}/experiences/${experienceId}/services`)
    .doc(serviceId)
    .update({ sales: reservations })
    .then((res) => {
      return true
    })
    .catch((err) => {
      console.log(err)
      return false
    })
}

function getServiceById(agencyId, experienceId, serviceId) {
  return firebaseDb
    .collection(`agency/${agencyId}/experiences/${experienceId}/services`)
    .doc(serviceId)
    .get()
    .then((doc) => {
      const data = { ...doc.data(), key: doc.id }
      return data
    })
}

function updateService(agencyId, experienceId, serviceId, data) {
  return firebaseDb
    .collection(`agency/${agencyId}/experiences/${experienceId}/services`)
    .doc(serviceId)
    .update(data)
    .then((res) => true)
    .catch((err) => {
      console.log(err)
      return false
    })
}

async function createService(agencyId, experienceId, service) {
  const serviceCollection = await firebaseDb
    .collection(`agency/${agencyId}/experiences/${experienceId}/services`)
    .add(service)

  const updateResponse = await updateService(
    agencyId,
    experienceId,
    serviceCollection.id,
    { key: serviceCollection.id },
  )

  return { updated: updateResponse, key: serviceCollection.id }
}

function updateReservationStatus(data, update) {
  const { agencyId, experienceId, reservationID } = data
  return firebaseDb
    .doc(
      `agency/${agencyId}/experiences/${experienceId}/reservation/${reservationID}`,
    )
    .update(update)
}

function insertCheckin(data) {
  const { agencyId, experienceId, reservationId, updateReservation } = data
  return firebaseDb
    .collection(`agency/${agencyId}/experiences/${experienceId}/reservation`)
    .doc(reservationId)
    .update(updateReservation)
}

async function createPassanger(queryData) {
  const { agencyId, experienceId, reservationId, passangerData } = queryData
  const passangerId = await firebaseDb
    .collection(
      `agency/${agencyId}/experiences/${experienceId}/reservation/${reservationId}/passengers`,
    )
    .add(passangerData)
    .then((docRef) => docRef.id)

  await firebaseDb
    .doc(
      `agency/${agencyId}/experiences/${experienceId}/reservation/${reservationId}/passengers/${passangerId}`,
    )
    .update({ key: passangerId })
  return passangerId
}

function getPassangers(queryData) {
  const { agencyId, experienceId, reservationId } = queryData
  return firebaseDb
    .collection(
      `agency/${agencyId}/experiences/${experienceId}/reservation/${reservationId}/passengers`,
    )
    .where('isActive', '==', true)
}

function deletePassanger(queryData) {
  const { agencyId, experienceId, reservationId, passangerId } = queryData

  return firebaseDb
    .doc(
      `agency/${agencyId}/experiences/${experienceId}/reservation/${reservationId}/passengers/${passangerId}`,
    )
    .update({ isActive: false })
}

function getPassengerById(queryData) {
  const { agencyId, experienceId, reservationId, passengerId } = queryData

  return firebaseDb
    .doc(
      `agency/${agencyId}/experiences/${experienceId}/reservation/${reservationId}/passengers/${passengerId}`,
    )
    .get()
    .then((doc) => doc.data())
}

async function createPassengerFile(queryData) {
  const {
    agencyId,
    experienceId,
    reservationId,
    passengerId,
    passengerFileData,
  } = queryData

  const passengerFileId = await firebaseDb
    .collection(
      `agency/${agencyId}/experiences/${experienceId}/reservation/${reservationId}/passengers/${passengerId}/passengerFile`,
    )
    .add(passengerFileData)
    .then((docRef) => docRef.id)

  await firebaseDb
    .doc(
      `agency/${agencyId}/experiences/${experienceId}/reservation/${reservationId}/passengers/${passengerId}/passengerFile/${passengerFileId}`,
    )
    .update({ key: passengerFileId })

  return passengerFileId
}

function updatePassenger(queryData) {
  const { agencyId, experienceId, reservationId, passengerId, passengerData } =
    queryData

  return firebaseDb
    .doc(
      `agency/${agencyId}/experiences/${experienceId}/reservation/${reservationId}/passengers/${passengerId}`,
    )
    .update(passengerData)
    .then(() => true)
    .catch((err) => {
      console.log(err)
      return false
    })
}

function updateReservation(agencyId, experienceId, reservationId, updateData) {
  return firebaseDb
    .doc(
      `agency/${agencyId}/experiences/${experienceId}/reservation/${reservationId}`,
    )
    .update(updateData)
    .then(() => true)
    .catch((err) => {
      console.log(err)
      return false
    })
}

function updateReservationReSchedule(
  agencyId,
  experienceId,
  reservationId,
  updateData,
) {
  return firebaseDb
    .doc(
      `agency/${agencyId}/experiences/${experienceId}/reservation/${reservationId}`,
    )
    .set(updateData, { merge: true })
    .then(() => true)
    .catch((err) => {
      console.log(err)
      return false
    })
}

async function updateReservationFlowOrder(
  agencyId,
  experienceId,
  reservationId,
  flowOrder,
) {
  try {
    await firebaseDb
      .doc(
        `agency/${agencyId}/experiences/${experienceId}/reservation/${reservationId}`,
      )
      .update({ flowOrder })
    return { updated: true, error: '' }
  } catch (err) {
    return { updated: false, error: err }
  }
}

async function updateOrderFlowOrder(
  agencyId,
  experienceId,
  orderId,
  flowOrder,
) {
  try {
    await firebaseDb
      .doc(`agency/${agencyId}/experiences/${experienceId}/order/${orderId}`)
      .update({ flowOrder })
    return { updated: true, error: '' }
  } catch (err) {
    return { updated: false, error: err }
  }
}

async function updateInvoiceFlowOrder(
  agencyId,
  experienceId,
  invoiceId,
  flowOrder,
) {
  try {
    await firebaseDb
      .doc(
        `agency/${agencyId}/experiences/${experienceId}/invoice/${invoiceId}`,
      )
      .update({ flowOrder })
    return { updated: true, error: '' }
  } catch (err) {
    return { updated: false, error: err }
  }
}

async function getExperienceServicesByType(agencyId, experienceId, type) {
  try {
    const serviceResponse = await firebaseDb
      .collection(`agency/${agencyId}/experiences/${experienceId}/services`)
      .get()

    let data = []
    serviceResponse.forEach((doc) => {
      data.push(doc.data())
    })
    return data
  } catch (err) {
    console.log(err)
  }
}

async function getExperienceServicesByDates(agencyId, experienceId, dates) {
  try {
    const serviceResponse = await firebaseDb
      .collection(`agency/${agencyId}/experiences/${experienceId}/services`)
      .where('startDate', '==', dates.startDate)
      .where('endDate', '==', dates.endDate)
      .get()

    let data = {}
    serviceResponse.forEach((doc) => {
      data = doc.data()
    })
    return data
  } catch (err) {
    console.log(err)
  }
}

function getLastReservationDetails(agencyId, experienceId, reservationId) {
  return firebaseDb
    .collection('agency')
    .doc(agencyId)
    .collection('experiences')
    .doc(experienceId)
    .collection('reservation')
    .doc(reservationId)
    .get()
    .then((doc) => {
      return doc.data()
    })
}

function getCodeDiscount(agencyId, experienceId, reservationId, couponId) {
  return firebaseDb
    .collection('agency')
    .doc(agencyId)
    .collection('coupons')
    .doc(couponId)
    .get()
    .then((doc) => {
      return doc.data()
    })
}

function getAllCoupons(agencyId) {
  return firebaseDb
    .collection('agency')
    .doc(agencyId)
    .collection('coupons')
    .get()
    .then((querySnapshot) => {
      const coupons = []
      querySnapshot.forEach((doc) => {
        coupons.push(doc.data())
      })
      return coupons
    })
}

function validationCoupon(agencyId, experience, code) {
  return firebaseDb
    .collection('agency')
    .doc(agencyId)
    .collection('coupons')
    .where('isActive', '==', true)
    .where('isDeals', '==', false)
    .get()
    .then((doc) => {
      if (doc.empty) {
        return []
      } else {
        const coupons = []
        for (let el of doc.docs) {
          coupons.push({ id: el.id, ...el.data() })
        }
        return coupons
      }
    })
}

//WEBPAY
async function updateStatusWebpay(reservationId, payment) {
  const res = await firebaseDb.collectionGroup('reservation').get()
  return res.forEach(async (doc) => {
    if (doc.id === reservationId) {
      return await firebaseDb
        .doc(doc.ref.path)
        .set({ ...payment }, { merge: true })
    }
  })
}

async function getDetailNewReservation(agencyId, experienceId, reservationId) {
  const res = await firebaseDb.collectionGroup('reservation').get()
  return res.forEach((docs) => {
    if (docs.id === reservationId) {
      return { id: docs.id, ...docs.data() }
    }
  })
}

const checkResourceUsage = async (agencyData, experienceData, reservationData) => {
  try {
    // Get experiences
    const refExp = await firebaseDb
      .collection(`agency/${agencyData.key}/experiences`)
      .where('channelRoomId', '!=', '')
      .where('isActive', '==', true).get();

    // Get resources
    const refRes = await firebaseDb
      .collection(`agency/${agencyData.key}/resources`)
      .where(
        'idsExperiences',
        'array-contains',
        !!experienceData.key ? experienceData.key : experienceData,
      )
      .where('isActive', '==', true).get();

    const experiences = []
    const singleResources = [];
    const nonSingleResources = [];

    // Store experiences
    for (let r of refExp.docs) {
      const expData = r.data();
      experiences.push(expData);
    }

    // Separate resources into single and non-single
    for (let r of refRes.docs) {
      const resourceData = r.data();
      if (!!resourceData.isSingle) {
        singleResources.push({ ...resourceData, id: r.ref.path });
      } else {
        nonSingleResources.push({ ...resourceData, id: r.ref.path });
      }
    }

    function countOccurrencesInObjects(date, resourceAvailability) {
      let count = 0;
      for (const key in resourceAvailability) {
        const obj = resourceAvailability[key];
        if (obj?.daysRange?.[date]) {
          count++;
        }
      }
      return count;
    };

    function countTotalUsedInObjects(date, resourceAvailability) {
      let count = 0;
      for (const key in resourceAvailability) {
        const obj = resourceAvailability[key];
        if (obj.daysRange[date]) {
          count += obj.used;
        }
      }
      return count;
    };


    const startDate = new Date(reservationData.dayFrom)
    const endDate = new Date(reservationData.dayTo)

    function* dateRange(startDate, endDate) {
      while (startDate < endDate) {
          yield startDate;
          startDate = new Date(startDate);
          startDate.setDate(startDate.getDate() + 1);
      }
    }

    //for (let currentDate = new Date(startDate); currentDate < endDate;) {
    for await (let currentDate of dateRange(startDate, endDate)) {

      const currentDateString = currentDate.toISOString().split('T')[0];
      let nextDate = new Date(currentDate);
      nextDate.setDate(nextDate.getDate() + 1); // This creates a new Date object for the next iteration


      for (let exp of experiences) {

        const singleResourcesNonAviable = []
        const nonSingleresourcesNonAviable = []


        const filteredSingleResources = singleResources.filter((resource) => resource.idsExperiences.includes(exp.key) && resource.isActive)
        const filteredNonSingleResources = nonSingleResources.filter((resource) => resource.idsExperiences.includes(exp.key) && resource.isActive)
        for await (const resource of filteredSingleResources) {
          // Get availability for the resource on the current date
          const availability = await checkAvailabilityUsage(agencyData.key, resource.id.split("/").pop());

          // chekear disponibilidad en base a la reserva previamente asignada
          if (resource.isPrivate) {

            const occurrences = countOccurrencesInObjects(currentDateString, availability);

            if (resource.quantity - occurrences <= 0) {
              // Si el recurso esta totalmente ocupado lo guardo
              console.log(resource.name, resource.quantity - occurrences)
              singleResourcesNonAviable.push(resource)
            }

          } else if (!resource.isPrivate) {

            const totalUsed = countTotalUsedInObjects(currentDateString, availability);

            if (resource.quota - totalUsed <= 0) {
              // Si el recurso esta totalmente ocupado lo guardo
              console.log(resource.quantity - totalUsed)
              singleResourcesNonAviable.push(resource)
            }
          }
        }

        for await (const resource of filteredNonSingleResources) {

          // Get availability for the resource on the current date
          const availability = await checkAvailabilityUsage(agencyData.key, resource.id.split("/").pop());

          // chekear disponibilidad en base a la reserva previamente asignada
          if (resource.isPrivate) {

            const occurrences = countOccurrencesInObjects(currentDateString, availability);

            if (resource.quantity - occurrences <= 0) {
              // Si el recurso esta totalmente ocupado lo guardo
              console.log(resource.name, resource.quantity - occurrences)
              nonSingleresourcesNonAviable.push(resource)
            }

          } else if (!resource.isPrivate) {

            const totalUsed = countTotalUsedInObjects(currentDateString, availability);
            if (resource.quota - totalUsed <= 0) {
              // Si el recurso esta totalmente ocupado lo guardo
              console.log(resource.quantity - totalUsed)
              nonSingleresourcesNonAviable.push(resource)
            }
          }
        }
        // Verifico si los recursos single no disponibles sean igual a los recursos totales
        if (filteredSingleResources.length > 0 && (filteredSingleResources.length - singleResourcesNonAviable.length === 0)) {
          // envio el id dentro de un array por futuros bloqueos de multiples room ids
          const block = await sendCloseAvailToChannel([exp.channelRoomId], 1, currentDateString, agencyData.wubookApiKey, agencyData.lcode);
          console.log(currentDateString, "block", block);
        } else {
          console.log(`Room ${exp.channelRoomId} at `, currentDateString, "No block");
        }

        // PARA LOS NO SINGLE nonSingleresourcesNonAviable TIENE QUE ESTAR VACIO (TODOS LOS RECURSOS DISPONIBLES)
        if (filteredNonSingleResources.length > 0 && nonSingleresourcesNonAviable.length > 0) {
          // envio el id dentro de un array por futuros bloqueos de multiples room ids
          const block = await sendCloseAvailToChannel([exp.channelRoomId], 1, currentDateString, agencyData.wubookApiKey, agencyData.lcode);
          console.log(currentDateString, "block", block);
        } else {
          console.log(`Room ${exp.channelRoomId} at `, currentDateString, "No block");
        }
      }
      currentDate = nextDate;
    }
  } catch (error) {
    console.log(error)
  }
}

const checkAvailabilityUsage = async (agencyId, resourceId) => {
  const query = firebaseDb.collection(
    `agency/${agencyId}/resources/${resourceId}/availability`,
  )
  const snapshot = await query.get()
  const resources = []
  snapshot.forEach((doc) => {
    resources.push({ ...doc.data(), resourceId: resourceId })
  })
  return resources
}

export {
  createReservation,
  getReservationDetails,
  getServiceByDayAndHour,
  getAllServices,
  createService,
  updateService,
  updateReservationStatus,
  insertCheckin,
  createPassanger,
  getPassangers,
  deletePassanger,
  getPassengerById,
  createPassengerFile,
  updatePassenger,
  updateServiceReservations,
  updateReservation,
  updateReservationReSchedule,
  updateReservationFlowOrder,
  updateOrderFlowOrder,
  updateInvoiceFlowOrder,
  getExperienceServicesByType,
  getExperienceServicesByDates,
  getResourcesByDayAndHour,
  getResourcesHotelByDayAndHour,
  assignResource,
  getLastReservationDetails,
  getCodeDiscount,
  validationCoupon,
  updateStatusWebpay,
  getDetailNewReservation,
  getAllReservationsForExperience,
  getAllCoupons,
  checkAvailabilityForResource,
  checkAvailabilityHotels,
  checkResourceUsage
}
